import { render } from "./TreeBuilder.vue?vue&type=template&id=4725382e&scoped=true"
import script from "./TreeBuilder.vue?vue&type=script&lang=js"
export * from "./TreeBuilder.vue?vue&type=script&lang=js"

import "./TreeBuilder.vue?vue&type=style&index=0&id=4725382e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4725382e"]])

export default __exports__